// @ts-check
import { Component } from '@verndale/core';
import { createFocusTrap } from 'focus-trap';
import { isSafari, KEYCODE } from '../../utils';

class Module extends Component {
  constructor(el) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      $trigger: this.el.querySelector('.site-selector__button'),
      $dropdown: this.el.querySelector('.site-selector__dropdown')
    };

    this.siteSelectorTrap = createFocusTrap(this.dom.$dropdown, {
      escapeDeactivates: true,
      clickOutsideDeactivates: true
    });
  }

  addListeners() {
    this.el.addEventListener('keydown', (e) =>
      this.handleSiteSelectorKeydown(e)
    );
    if (isSafari()) {
      document.addEventListener(
        'click',
        (e) => this.handleClickOutside(e),
        true
      );
    } else {
      this.el.addEventListener('focusout', (e) =>
        this.handleSiteSelectorFocusout(e)
      );
    }
    this.dom.$trigger.addEventListener('click', (e) =>
      this.handleSiteSelectorClick(e)
    );
  }

  handleClickOutside(e) {
    if (
      !this.dom.$trigger.contains(e.target) &&
      !this.dom.$dropdown.contains(e.target)
    ) {
      this.siteSelectorTrap?.deactivate?.();
      this.dom.$trigger.setAttribute('aria-expanded', false);
    }
  }

  handleSiteSelectorKeydown(e) {
    if (e.keyCode === KEYCODE.ESCAPE) {
      e.stopPropagation();
      this.dom.$trigger.setAttribute('aria-expanded', false);
    }
  }

  handleSiteSelectorFocusout(e) {
    if (
      this.dom.$trigger !== e.relatedTarget &&
      !this.dom.$dropdown.contains(e.relatedTarget)
    ) {
      this.siteSelectorTrap?.deactivate?.();
      this.dom.$trigger.setAttribute('aria-expanded', false);
    }
  }

  handleSiteSelectorClick(e) {
    const isExpanded = e.currentTarget.getAttribute('aria-expanded') === 'true';
    e.currentTarget.setAttribute('aria-expanded', !isExpanded);
    if (isExpanded) this.siteSelectorTrap?.deactivate?.();
    else this.siteSelectorTrap?.activate?.();
  }
}

export default Module;
